import React from "react";
import Overlay from "../Overlay";

/**
 * Condiciones de una promoción. Se abre desde la tarjeta.
 */
const PromoDialog = ({ promo, onClose }) => {

	if (!promo) return null;

	return (
		<Overlay label={ `Condiciones de ${promo.marca}` } onClose={ onClose }>
			<div className="relative w-full max-w-[640px] bg-white px-6 pb-8 pt-10 shadow-[0_40px_120px_rgba(0,0,0,.35)] sm:px-11 sm:pb-11">
				<button
					type="button"
					onClick={ onClose }
					aria-label="Cerrar"
					className="absolute right-3 top-3 h-10 w-10 text-3xl font-extralight text-muted transition-colors duration-200 hover:text-ink"
				>
					×
				</button>

				<p className="eyebrow">Condiciones</p>
				<h2 className="mb-5 mt-3.5 text-[32px] leading-none tracking-headline font-semibold sm:text-[42px]">
					{ promo.marca }
				</h2>

				{
					promo.condiciones?.map((block, index) => (
						<div key={ index } className={ index > 0 ? "mt-5" : "" }>
							{
								block.subtitulo &&
									<p className="text-sm font-bold text-ink">{ block.subtitulo }</p>
							}
							<ul className="mt-2 list-disc pl-5">
								{
									block.items.map((item, itemIndex) => (
										<li key={ itemIndex } className="text-sm leading-relaxed text-muted">{ item }</li>
									))
								}
							</ul>
						</div>
					))
				}

				{
					promo.nota &&
						<p className="mt-6 border-t border-line pt-5 text-xs leading-relaxed text-muted">{ promo.nota }</p>
				}
			</div>
		</Overlay>
	);
};

export default PromoDialog;
